import React, { useReducer, useState } from "react";
import { Box, FormControl, FormHelperText, Icon, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import { useNavigate } from "react-router-dom";
import { signInState, signInStateMange, userLogin } from "./signData";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { useLoading } from "../../../../context/LodingContext";
import Swal from "sweetalert2";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { useEffect } from "react";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import routes from "../../../../routes";
import URL from "../../../../pages/Utils/url";
import { Email, HomeRepairServiceOutlined, Password } from "@mui/icons-material";

const SignInputField = () => {
  const [signInData, dispatch] = useReducer(signInStateMange, signInState);
  const [viewPassword, setViewPassword] = useState(false);
  const {
    setAuthenticated,

    setUserID,
    setAccess,

    setUserImage,

    setUserDetails,
  } = useAuthData();
  const { setCirleLoading } = useLoading();
  const { setItem } = useLocalStorage("access");
  const navigate = useNavigate();
  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };
  useEffect(() => {
    setAuthenticated(false);
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const keydownHandler = (event) => {
    if (
      event.key == "Enter" &&
      signInData.emailStatus === "success" &&
      signInData.passwordStatus === "success"
    ) {
      handleSignIn();
    }
  };

  const handleSignIn = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, userLogin, {
        email: signInData?.email,

        password: signInData?.password,
      });

      const userDetails = await res?.userLogin;
      const webuse = await res?.userLogin?.webUse;
      const success = await res?.userLogin?.success;
      const message = await res?.userLogin?.message;
      const user_id = await res?.userLogin?.id;
      const access = await res?.userLogin?.access;
      const image = (await res?.userLogin?.image)
        ? `${URL}media/${res?.userLogin?.image}`
        : null;
      setUserDetails(userDetails);
      setUserImage(image);
      // Step 1: get module names from role access array
      const accessibleModules =
        access?.filter((item) => item.can_access).map((item) => item.module) ||
        [];

      // Step 2: Find the first route in the routes array that matches an accessible module
      let routeToNavigate = null;

      // Iterate over the routes array
      for (let route of routes) {
        // Check if the module of the current route is in the accessibleModules
        if (accessibleModules.includes(route.module)) {
          if (route.collapse && route.collapse.length > 0) {
            // Look for the first accessible collapse route
            const accessibleCollapseRoute = route.collapse.find(
              (collapseRoute) =>
                accessibleModules.includes(collapseRoute.module) &&
                collapseRoute.protected === true
            );

            // If an accessible collapse route is found, navigate to it
            if (accessibleCollapseRoute) {
              routeToNavigate = accessibleCollapseRoute.route;
              break;
            }
          }

          // If no collapse route was found, navigate to the top-level route
          if (!routeToNavigate) {
            routeToNavigate = route.route;
            break;
          }
        }
      }

      setUserID(user_id);
      setAccess(access);
      setItem(access);
      localStorage.setItem("userID", JSON.stringify(user_id));
      localStorage.setItem("userImage", JSON.stringify(image));
      localStorage.setItem("userDetails", JSON.stringify(userDetails));
      localStorage.setItem("refresh", true);
      if (success) {
        if (webuse) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 2000,
            didOpen: () => {
              document.querySelector(".swal2-popup").style.zIndex =
                "999999999999999";
            },
          }).then(() => {
            localStorage.setItem("loginStatus", true);
            setAuthenticated(true);
            // Step 3: Navigate to the first matched route else default /dashboard
            if (routeToNavigate) {
              // navigate(routeToNavigate);
              navigate("/dashboard");
            } else {
              navigate("/dashboard");
            }
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: "Web not use this person",
            showConfirmButton: true,
            didOpen: () => {
              document.querySelector(".swal2-popup").style.zIndex =
                "999999999999999";
            },
          });
        }
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "999999999999999";
          },
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      signInData.emailStatus === "success" &&
      signInData.passwordStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  return (
    <Box sx={{ width: "100%", maxWidth: "380px" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        {/* Username / Email Field */}
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#ffffff",
              borderRadius: "4px",
              padding: "4px 12px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              border:
                signInData.emailStatus === "error"
                  ? "1px solid #d32f2f"
                  : "1px solid transparent",
            }}
          >
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={signInData.email}
              onKeyDown={keydownHandler}
              onChange={(e) =>
                dispatch({ value: e?.target?.value, name: "email" })
              }
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                fontSize: "14px",
                color: "#333",
                padding: "8px 0",
                background: "transparent",
              }}
            />
             <Email
      sx={{
        color: '#777',
        fontSize: 20,
        ml: 1
      }}/>
          </Box>
          {signInData.emailStatus === "error" && (
            <FormControl sx={{ position: "absolute", bottom: "-20px", left: 0 }} error>
              <FormHelperText sx={{ color: "#ff8b8b !important", m: 0, fontSize: "11px" }}>
                Please enter valid email address
              </FormHelperText>
            </FormControl>
          )}
        </Box>

       
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#ffffff",
              borderRadius: "4px",
              padding: "4px 12px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              border:
                signInData.passwordStatus === "error"
                  ? "1px solid #d32f2f"
                  : "1px solid transparent",
            }}
          >
            <input
              type={viewPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={signInData.password}
              onKeyDown={keydownHandler}
              onChange={(e) =>
                dispatch({ value: e?.target?.value, name: "password" })
              }
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                fontSize: "14px",
                color: "#333",
                padding: "8px 0",
                background: "transparent",
              }}
            />
             <Password
      sx={{
        color: '#777',
        fontSize: 20,
        ml: 1
      }}/>
          </Box>
          {signInData.passwordStatus === "error" && (
            <FormControl sx={{ position: "absolute", bottom: "-22px", left: 0 }} error>
              <FormHelperText sx={{ color: "#ff8b8b !important", m: 0, fontSize: "11px" }}>
                Your password must be min 8 and max 15 characters.
              </FormHelperText>
            </FormControl>
          )}
        </Box>

        
        <Box sx={{ mt: 1 }}>
          <button
            type="button"
            onClick={handleSignIn}
            disabled={!checkAllFields()}
            style={{
              width: "100%",
              padding: "11px 0",
              backgroundColor: checkAllFields() ? "#05a85c" : "#05a85ca6",
              color: "#ffffff",
              border: "none",
              borderRadius: "4px",
              fontSize: "14px",
              fontWeight: 600,
              letterSpacing: "1px",
              cursor: checkAllFields() ? "pointer" : "not-allowed",
              transition: "all 0.3s ease",
              boxShadow: "0 3px 8px rgba(5, 168, 92, 0.4)",
            }}
            onMouseOver={(e) => {
              if (checkAllFields()) e.currentTarget.style.backgroundColor = "#048c4d";
            }}
            onMouseOut={(e) => {
              if (checkAllFields()) e.currentTarget.style.backgroundColor = "#05a85c";
            }}
          >
            LOGIN
          </button>
        </Box>

    
        <Box sx={{ textAlign: "center", mt: 0.5 }}>
          <Typography
            onClick={() => {
              navigate("/sign-in/forgotemail");
            }}
            sx={{
              display: "inline-block",
              color: "rgba(255, 255, 255, 0.85)",
              fontSize: "13px",
              cursor: "pointer",
              transition: "color 0.2s",
              "&:hover": {
                color: "#ffffff",
                textDecoration: "underline",
              },
            }}
          >
            Forgot Password?
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SignInputField;
